import { render } from "./event-modal-window.vue?vue&type=template&id=9716a930&scoped=true&ts=true"
import script from "./event-modal-window.vue?vue&type=script&lang=ts"
export * from "./event-modal-window.vue?vue&type=script&lang=ts"

import "./event-modal-window.vue?vue&type=style&index=0&id=9716a930&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9716a930"]])

export default __exports__